/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_StopInputs */

const en_common_stop = /** @type {(inputs: Common_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

const es_common_stop = /** @type {(inputs: Common_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detener`)
};

/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Common_StopInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_stop = /** @type {((inputs?: Common_StopInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_StopInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_stop(inputs)
	return en_common_stop(inputs)
});